import keyMirror from 'keymirror';

export const selectOwnerModalActionTypes = keyMirror({
	TOGGLE_SELECT_OWNER_MODAL: null,
	SET_GROUP_OWNER: null,
	SET_GROUP_OWNER_SUCCESS: null,
	SET_GROUP_OWNER_ERROR: null,
	CLEAN_SET_GROUP_OWNER_MODAL_STATE: null,
});
